/** The help centre on `front` (GOO-474); `frontDomain` is per environment. */
export const helpCentreUrl = (frontDomain: string) => `${frontDomain}/help`;
